import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var UpdateDoctorRes;
export const UpdateDoctorTodo = createAsyncThunk('UpdateDoctor', async (data) => {
    try {
        const res = await axios({
            method: "Put",
            url: process.env.REACT_APP_API_URL + `admin/doctor/${data.id}`,
            data: data.data,
            headers: { "Content-Type": "multipart/form-data",  "Authorization": 'Bearer ' + localStorage.getItem('user_token')}
        })
        return UpdateDoctorRes = res.data
        
    } catch (error) {
        return UpdateDoctorRes = error.response.data
    }
})